export default __webpack_public_path__ + "static/media/mint-img.b6f501d8.gif";